/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_DeniedInputs */



/**
* | output |
* | --- |
* | "The sign-in was cancelled. Try again or use the email link." |
*
* @param {Portal_X13_Error_DeniedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_denied = /** @type {((inputs?: Portal_X13_Error_DeniedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_DeniedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("The sign-in was cancelled. Try again or use the email link.")
});